export interface Rectangle {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface MapPickup {
  id: string;
  kind: "health" | "shotgun" | "machineGun" | "rocket" | "grenade";
  x: number;
  y: number;
}

export interface MapDefinition {
  id: string;
  name: string;
  width: number;
  height: number;
  backdrop: number;
  accent: number;
  solids: Rectangle[];
  spawns: { x: number; y: number }[];
  crates: Rectangle[];
  pickups: MapPickup[];
}

const floor = (width: number, y: number): Rectangle => ({ x: 0, y, width, height: 80 });

export const MAPS: MapDefinition[] = [
  {
    id: "foundry",
    name: "Ash Foundry",
    width: 1600,
    height: 900,
    backdrop: 0x0b0b12,
    accent: 0xff5948,
    solids: [
      floor(1600, 820),
      { x: 100, y: 650, width: 330, height: 26 },
      { x: 1170, y: 650, width: 330, height: 26 },
      { x: 520, y: 550, width: 560, height: 28 },
      { x: 0, y: 350, width: 300, height: 26 },
      { x: 1300, y: 350, width: 300, height: 26 },
      { x: 610, y: 270, width: 380, height: 24 },
    ],
    spawns: [
      { x: 160, y: 590 }, { x: 1380, y: 590 }, { x: 650, y: 480 }, { x: 950, y: 480 },
      { x: 120, y: 290 }, { x: 1480, y: 290 }, { x: 700, y: 210 }, { x: 900, y: 210 },
    ],
    crates: [
      { x: 380, y: 760, width: 56, height: 60 }, { x: 1164, y: 760, width: 56, height: 60 },
      { x: 775, y: 490, width: 50, height: 60 },
    ],
    pickups: [
      { id: "f-health", kind: "health", x: 800, y: 780 },
      { id: "f-shotgun", kind: "shotgun", x: 800, y: 510 },
      { id: "f-rocket", kind: "rocket", x: 800, y: 230 },
    ],
  },
  {
    id: "catacomb",
    name: "Neon Catacomb",
    width: 1600,
    height: 900,
    backdrop: 0x080d14,
    accent: 0x32d6ff,
    solids: [
      floor(1600, 820),
      { x: 0, y: 600, width: 430, height: 28 },
      { x: 1170, y: 600, width: 430, height: 28 },
      { x: 540, y: 690, width: 520, height: 24 },
      { x: 220, y: 390, width: 470, height: 26 },
      { x: 910, y: 390, width: 470, height: 26 },
      { x: 650, y: 180, width: 300, height: 24 },
    ],
    spawns: [
      { x: 120, y: 540 }, { x: 1480, y: 540 }, { x: 620, y: 630 }, { x: 980, y: 630 },
      { x: 300, y: 330 }, { x: 1300, y: 330 }, { x: 700, y: 120 }, { x: 900, y: 120 },
    ],
    crates: [
      { x: 405, y: 760, width: 56, height: 60 }, { x: 1139, y: 760, width: 56, height: 60 },
      { x: 665, y: 330, width: 52, height: 60 }, { x: 883, y: 330, width: 52, height: 60 },
    ],
    pickups: [
      { id: "c-health", kind: "health", x: 800, y: 650 },
      { id: "c-mg", kind: "machineGun", x: 800, y: 780 },
      { id: "c-grenade", kind: "grenade", x: 800, y: 140 },
    ],
  },
  {
    id: "spire",
    name: "Broken Spire",
    width: 1600,
    height: 900,
    backdrop: 0x100d17,
    accent: 0xbc72ff,
    solids: [
      floor(1600, 820),
      { x: 100, y: 680, width: 380, height: 26 },
      { x: 1120, y: 680, width: 380, height: 26 },
      { x: 580, y: 610, width: 440, height: 26 },
      { x: 50, y: 400, width: 340, height: 24 },
      { x: 1210, y: 400, width: 340, height: 24 },
      { x: 520, y: 340, width: 560, height: 26 },
      { x: 690, y: 120, width: 220, height: 22 },
    ],
    spawns: [
      { x: 150, y: 620 }, { x: 1450, y: 620 }, { x: 650, y: 550 }, { x: 950, y: 550 },
      { x: 140, y: 340 }, { x: 1460, y: 340 }, { x: 700, y: 280 }, { x: 900, y: 280 },
    ],
    crates: [
      { x: 470, y: 760, width: 55, height: 60 }, { x: 1075, y: 760, width: 55, height: 60 },
      { x: 774, y: 550, width: 52, height: 60 },
    ],
    pickups: [
      { id: "s-health", kind: "health", x: 800, y: 570 },
      { id: "s-shotgun", kind: "shotgun", x: 220, y: 640 },
      { id: "s-rocket", kind: "rocket", x: 1380, y: 640 },
      { id: "s-grenade", kind: "grenade", x: 800, y: 80 },
    ],
  },
];

export const getMap = (id: string): MapDefinition => MAPS.find((map) => map.id === id) ?? MAPS[0]!;
